import { useBreadcrumb } from "hooks/useBreadcrumb";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import EditManageAutoPay from "components/Payments/ManageAutoPay/EditManageAutoPay";
import ViewManageAutoPay from "components/Payments/ManageAutoPay/ViewManageAutoPay";
import SetupNewAutoPay from "components/Payments/ManageAutoPay/SetupNewAutoPay";
import AccessDenied from "routes/access-denied";

export default function ManageAutoPay() {
  const { t } = useTranslation();
  const { policies } = useSelector((state) => state.data);
  const { policy_id } = useParams();
  const [selectedPolicy, setSelectedPolicy] = useState();
  const [manageAutoPayMode, setManageAutoPayMode] = useState("view");

  useEffect(() => {
    if (policies?.length > 0) {
      let policy = policies?.find((p) => p.contractID === policy_id);
      if (policy) {
        setSelectedPolicy(policy);
        if (
          policy?.billingTypeCode !== "02" &&
          policy?.billingTypeCode !== "06"
        )
          setManageAutoPayMode("setupnewautopay");
      }
    }
  }, [policies, policy_id]);

  useBreadcrumb([
    { name: t("CustomerManagePayment-home"), url: "/policies" },
    { name: t("CustomerManagePayment-payments"), url: "/payment" },
    { name: t("CustomerManagePayment-manage-payment-methds"), url: "#" },
  ]);
  return (
    <>
      {manageAutoPayMode === "view" && (
        <ViewManageAutoPay
          selectedPolicy={selectedPolicy}
          setManageAutoPayMode={setManageAutoPayMode}
        />
      )}
      {manageAutoPayMode === "edit" && (
        <EditManageAutoPay
          selectedPolicy={selectedPolicy}
          setManageAutoPayMode={setManageAutoPayMode}
          manageAutoPayMode={manageAutoPayMode}
        />
      )}
      {manageAutoPayMode === "setupnewautopay" &&
        (selectedPolicy?.billingTypeCode === "08" ||
        selectedPolicy?.billingTypeCode === "09" ? (
          <AccessDenied />
        ) : (
          <SetupNewAutoPay selectedPolicy={selectedPolicy} />
        ))}
    </>
  );
}
